import { graphql } from "@cappelendamm/crystallize-types/subscriptions/gql";
export const getSubscriptionCancelDate = async ({ subscriptionContractId }, { client }) => {
    const eventTypes = ["cancelled"];
    const first = 1;
    const sort = "desc";
    const response = await client.subscriptions.request(graphql(`
      query SubscriptionContractEvents(
        $subscriptionContractId: ID!
        $eventTypes: [SubscriptionContractEventType!]
        $first: Int
        $sort: SortDirection
      ) {
        subscriptionContractEvents {
          getMany(
            subscriptionContractId: $subscriptionContractId
            eventTypes: $eventTypes
            first: $first
            sort: $sort
          ) {
            edges {
              node {
                createdAt
              }
            }
          }
        }
      }
    `), { subscriptionContractId, eventTypes, first, sort });
    const cancelEvent = response.subscriptionContractEvents?.getMany?.edges?.[0] || null;
    return cancelEvent ? cancelEvent.node.createdAt : null;
};
